import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgFileBigPdf({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 40 40"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M28.25 3.75c1.8 0 3.25 1.46 3.25 3.25v8H29V7a.75.75 0 00-.75-.75h-12.9V12c0 1.65-1.3 3-2.92 3.1H6.5V33c0 .41.34.75.75.75h21c.41 0 .75-.34.75-.75v-3h2.5v3c0 1.8-1.46 3.25-3.25 3.25h-21A3.25 3.25 0 014 33V14c0-.33.13-.65.37-.88l9-9c.23-.24.55-.37.88-.37h14zM13.78 18c.68 0 1.2.05 1.58.16A2.4 2.4 0 0117 19.6c.14.35.21.74.21 1.18 0 .93-.3 1.65-.88 2.14-.58.49-1.43.72-2.54.72H12.4v2.24c0 .39-.1.7-.3.92a1 1 0 01-.77.34c-.31 0-.58-.12-.78-.34-.2-.22-.29-.52-.29-.91v-6.62c0-.44.1-.76.33-.97.22-.2.54-.3.97-.3h2.23zm19.7 0c.32 0 .58.08.75.24.18.16.27.37.27.63s-.09.47-.27.63c-.17.17-.43.24-.75.24h-3.23v1.8h2.67c.3 0 .55.07.73.23.17.16.26.37.26.63a.8.8 0 01-.27.62c-.17.15-.42.23-.72.23h-2.67v2.63c0 .4-.1.72-.3.93a1 1 0 01-.76.33 1 1 0 01-.78-.33c-.2-.22-.3-.53-.3-.93v-6.61c0-.28.04-.51.13-.7a.9.9 0 01.45-.44c.19-.09.42-.13.69-.13h4.1zm-11.15 0c.6 0 1.13.06 1.57.17.45.12.86.34 1.23.66.94.8 1.41 2.02 1.41 3.64a7.2 7.2 0 01-.14 1.45 3.78 3.78 0 01-1.2 2.18 3.18 3.18 0 01-1.74.81c-.32.05-.69.08-1.1.08H20.1a1.6 1.6 0 01-.82-.17.87.87 0 01-.4-.52c-.05-.2-.08-.44-.08-.73v-6.3c0-.43.1-.75.31-.96.21-.21.53-.31.96-.31h2.26zm-.44 1.78h-.95v5.43h1.28l.28-.01.22-.02a1.59 1.59 0 00.86-.33c.53-.45.8-1.24.8-2.39a3.5 3.5 0 00-.36-1.8 1.5 1.5 0 00-.83-.72c-.3-.09-.65-.14-1.05-.16h-.25zm-8.53-.07h-.97v2.22h.97c.4 0 .72-.04.97-.12a1 1 0 00.53-.35c.12-.16.18-.37.18-.65 0-.33-.1-.59-.28-.78-.18-.19-.58-.3-1.19-.32h-.2zm-.21-11.84L8.12 12.9h4.13a.9.9 0 00.9-.79V7.87z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgFileBigPdf.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgFileBigPdf.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgFileBigPdf svgRef={ref} {...props} />);
export default ForwardRef;
